<template>
  <div :class="{ 'order-search-bar': true }">
    <div class="search-top-bar flex-col">
      <div class="search-bar-wrap flex-row">
        <div class="search-bar-left flex-col justify-between">
          <span class="text_10">{{$t('texts.waybillNo')}}</span>
          <el-input
            class="search-input"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            :placeholder="$t('placeholder.max50waybillNosAndSplit')"
            v-model="textareaText"
          ></el-input>
        </div>
        <div @click="searchFunc" class="search-btn flex-col">
          <div class="search-btn-icon flex-col"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { $t } from "~/utils/index.js";
export default {
  name: "OrderSearchMobileBar",
  setup() {
    // Use ref to create a reactive variable for textarea text
    const textareaText = ref("");

    // Search function
    const searchFunc = () => {
      window.location.href = `https://wxfront-zmb.platform.omszt.com/#/findOrder/result?documentCodes=${textareaText.value}`;
    };

    return {
      textareaText,
      searchFunc,
    };
  },
};
</script>

<style scoped>
/* Add your existing scoped styles here */
.block_37 {
  height: 244px;
  background-size: 1477px 356px;
  width: 1372px;
}

.block_38 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 16px;
  width: 1307px;
  height: 188px;
  border: 1px solid rgba(238, 238, 238, 1);
  margin: 28px 0 0 28px;
}

.text-group_51 {
  width: 96px;
  height: 88px;
  margin: 49px 0 0 47px;
}

.text_210 {
  width: 96px;
  height: 45px;
  overflow-wrap: break-word;
  color: rgba(44, 46, 45, 1);
  font-size: 32px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 45px;
}

.text_211 {
  width: 72px;
  height: 33px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 24px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 33px;
  margin-top: 10px;
}

.box_71 {
  width: 24px;
  height: 24px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng7fbf4a84307b660fece75723164efe7f6e1b682f48d8bd2fd9f4756f659b03e5)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 108px 0 0 44px;
}

.text-group_52 {
  width: 96px;
  height: 88px;
  margin: 49px 0 0 90px;
}

.text_212 {
  width: 96px;
  height: 45px;
  overflow-wrap: break-word;
  color: rgba(44, 46, 45, 1);
  font-size: 32px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 45px;
}

.text_213 {
  width: 72px;
  height: 33px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 24px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 33px;
  margin-top: 10px;
}

.box_72 {
  width: 24px;
  height: 24px;
  background: url(~/assets/arrow-down.png) 100% no-repeat;
  background-size: 100% 100%;
  margin: 108px 0 0 44px;
}

.text-group_53 {
  width: 128px;
  height: 88px;
  margin: 49px 0 0 90px;
}

.text_214 {
  width: 128px;
  height: 45px;
  overflow-wrap: break-word;
  color: rgba(44, 46, 45, 1);
  font-size: 32px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 45px;
}

.text_215 {
  width: 72px;
  height: 33px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 24px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 33px;
  margin-top: 10px;
}

.box_73 {
  width: 24px;
  height: 24px;
  background: url(~/assets/arrow-down.png) 100% no-repeat;
  background-size: 100% 100%;
  margin: 108px 0 0 12px;
}

.text-group_54 {
  width: 128px;
  height: 88px;
  margin: 49px 0 0 90px;
}

.text_216 {
  width: 128px;
  height: 45px;
  overflow-wrap: break-word;
  color: rgba(44, 46, 45, 1);
  font-size: 32px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 45px;
}

.text_217 {
  width: 72px;
  height: 33px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 24px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 33px;
  margin-top: 10px;
}

.text_218 {
  width: 35px;
  height: 33px;
  overflow-wrap: break-word;
  color: rgba(73, 73, 73, 1);
  font-size: 24px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 33px;
  margin: 104px 0 0 12px;
}

.box_74 {
  background-color: rgba(44, 46, 45, 1);
  border-radius: 16px;
  height: 138px;
  width: 138px;
  margin: 24px 26px 0 159px;
}

.block_39 {
  width: 40px;
  height: 40px;
  background: url(~/assets/search-icon.png) 100% no-repeat;
  background-size: 100% 100%;
  margin: 49px 0 0 49px;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}

.search-top-bar {
  box-shadow: 16px 36px 56px 0px rgba(0, 51, 102, 0.06);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 16px;

  justify-content: flex-center;
}

.search-bar-wrap {
  justify-content: space-between;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 16px;

  height: 188px;
  border: 1px solid rgba(238, 238, 238, 1);
  margin: 28px;
}

.search-bar-left {
  flex: 1;

  margin: 49px 0 0 47px;
}

.text_10 {
  width: 96px;
  height: 45px;
  overflow-wrap: break-word;
  color: rgba(44, 46, 45, 1);
  font-size: 32px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 45px;
}

.search-input {
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 24px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 33px;
  margin-top: 10px;
}
.search-input :deep( .el-textarea__inner) {
  border: none;
  padding: 0;
  box-shadow: none;
  max-height: 50px;
}
.search-btn {
  background-color: rgba(44, 46, 45, 1);
  border-radius: 16px;
  height: 138px;
  width: 138px;
  margin: 24px 24px 0 0px;
  cursor: pointer;
}
.search-btn:hover {
  background: #000;
}

.search-btn-icon {
  width: 40px;
  height: 40px;
  background: url(~/assets/search-icon.png) 100% no-repeat;
  background-size: 100% 100%;
  margin: 49px 0 0 49px;
}

.search-history {
  height: 40px;
  margin: 0px 0 28px 75px;
}

.search-history-item {
  background-color: rgba(242, 242, 242, 1);
  border-radius: 16px 13px 13px 13px;
  padding: 5px 10px;
  height: 40px;
  margin-right: 10px;
  cursor: pointer;
}

.search-history-item-text {
  flex: 1;
  height: 28px;
  overflow-wrap: break-word;
  color: rgba(151, 161, 179, 1);
  font-size: 20px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}

.search-history-item-close {
  width: 18px;
  height: 18px;
  background: url(~/assets/close-gray-icon.png) 100% no-repeat;
  background-size: 100% 100%;
  margin-top: 5px;
  margin-left: 10px;
}

.block_6 {
  background-color: rgba(242, 242, 242, 1);
  border-radius: 16px 13px 13px 13px;
  width: 214px;
  height: 40px;
}

.image-text_2 {
  width: 194px;
  height: 28px;
  margin: 6px 0 0 11px;
}

.text-group_2 {
  width: 168px;
  height: 28px;
  overflow-wrap: break-word;
  color: rgba(151, 161, 179, 1);
  font-size: 20px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}

.group_5 {
  width: 18px;
  height: 18px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng10d21fcd829d916c9925cebcbf7ec1fb1acf8b39edb3f45398c6515397816e6d)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: 5px;
}

.search-all-history {
  height: 40px;
  margin: 27px auto;
  width: 1400px;
}
.search-all-history .search-history {
  margin: 0;
}
.search-all-history-label {
  width: 120px;
  height: 33px;
  overflow-wrap: break-word;
  color: rgba(44, 46, 45, 1);
  font-size: 24px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 33px;
  margin-top: 3px;
}

.group_6 {
  background-color: rgba(242, 242, 242, 1);
  border-radius: 16px 13px 13px 13px;
  width: 214px;
  height: 40px;
}

.image-text_3 {
  width: 194px;
  height: 28px;
  margin: 6px 0 0 11px;
}

.text-group_3 {
  width: 168px;
  height: 28px;
  overflow-wrap: break-word;
  color: rgba(151, 161, 179, 1);
  font-size: 20px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}

.section_8 {
  width: 18px;
  height: 18px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng10d21fcd829d916c9925cebcbf7ec1fb1acf8b39edb3f45398c6515397816e6d)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: 5px;
}
</style>
